import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import LoginAndRegist from './views/LoginAndRegist.vue'
import PerfectInfo from './views/PerfectInfo.vue'
import Personal from './views/Personal.vue'
import SuccessCase from './views/SuccessCase.vue'
import SuccessCaseList from './views/SuccessCaseList.vue'
import SuccessCaseDetail from './views/SuccessCaseDetail.vue'
import Mail from './views/Mail.vue'
import HospitalList from './views/HospitalList.vue'
import DoctorList from './views/doctorList.vue'
import DoctorInfo from './views/DoctorInfo.vue'
import HospitalInfo from './views/HospitalInfo.vue'
import InternationalIndex from './views/InternationalIndex.vue'
import InternationalMedicine from './views/InternationalMedicine.vue'
import InternationalBodyCheck from './views/InternationalBodyCheck.vue'
import InternationalAntiAging from './views/InternationalAntiAging.vue'
import InternationalAdvanced from './views/InternationalAdvanced.vue'
import InternationalConsultation from './views/InternationalConsultation.vue'
import InternationalDisease from './views/InternationalDisease.vue'
import JapaneseMedical from './views/JapaneseMedical.vue'
import CorporateKnowledge from './views/CorporateKnowledge.vue'
import CorporateKnowledgeDetail from './views/CorporateDetail.vue'
import Form from './views/Form.vue'
import FormOfOne from './views/FormOfOne.vue'
import FormOfTwo from './views/FormOfTwo.vue'
import FormOfThree from './views/FormOfThree.vue'
import Upload from './views/Upload.vue'
import Agreements from './views/Agreements.vue'
import Signature from './views/Signature.vue'
import Myfile from './views/Myfile.vue'
import Illness from './views/Illness.vue'
import Pay from './views/Pay.vue'
import Rescue from './views/Rescue.vue'
import RescueOfExpericence from './views/RescueOfExpericence.vue'
import RescueOfPersonalized from './views/RescueOfPersonalized.vue'
import RescueOfWorldNet from './views/RescueOfWorldNet.vue'
import RescueOfIndividualCase from './views/RescueOfIndividualCase.vue'
import RescueOfOverseasService from './views/RescueOfOverseasService.vue'
import RescueOfOtherService from './views/RescueOfOtherService.vue'
import RescueOfMemberService from './views/RescueOfMemberService.vue'
import RescueOfEmergencyInChina from './views/RescueOfEmergencyInChina.vue'
import RescueOfCustomerService from './views/RescueOfCustomerService.vue'
import RescueOfGlobalClub from './views/RescueOfGlobalClub.vue'
import SubmitQues from './views/SubmitQues.vue'
import Recruitment from './views/Recruitment.vue'
import RecruitmentInfo from './views/RecruitmentInfo.vue'
import VIPService from './views/VIPService.vue'
import InternationalMedicalVisa from './views/InternationalMedicalVisa.vue'
import SJHome from './views/sj/SJHome.vue'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/home',
      name: 'home',
      meta: {
        title: '海外医疗-出国看病-全球救援-紧急救援-威马捷-EAJ',
        routeInfo: [
          { name: '首页', path: '/home' },
        ]
      },
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      meta: {
        title: '海外医疗-出国看病-全球救援-紧急救援-威马捷-EAJ',
        routeInfo: [
          { name: '关于', path: '/about' },
        ]
      },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }, {
      path: '/companyInfotion',
      name: 'CompanyInformation',
      meta: {
        title: '海外医疗-出国看病-全球救援-紧急救援-威马捷-EAJ',
        routeInfo: [
          { name: '关于', path: '/companyInformation' },
        ]
      },
      component: () => import(/* webpackChunkName: "about" */ './views/CompanyInformation.vue')
    },
    {
      path: '/activities',
      name: 'activities',
      meta: {
        routeInfo: [
          { name: '关于', path: '/activities' },
        ]
      },
      component: () => import('./views/Activities.vue')
    }, {
      path: '/assistances',
      name: 'assistances',
      meta: {
        routeInfo: [
          { name: '关于', path: '/assistances' },
        ]
      },
      component: () => import('./views/Assistances.vue')
    },
    {
      path: '/login/:type',
      name: 'login',
      component: LoginAndRegist,
      meta: {
        title: '登录',
        routeInfo: [
          { name: '登录', path: '/login/1' },
          { name: '注册', path: '/login/2' },
        ]
      },
    },
    {
      path: '/perfectInfo',
      name: 'perfectInfo',
      component: PerfectInfo,
      meta: {
        title: '完善信息',
        routeInfo: [
          { name: '完善信息', path: '/perfectInfo' },
        ]
      },
    },
    {
      path: '/personal',
      name: 'personal',
      component: Personal,
      meta: {
        title: '个人中心',
        routeInfo: [
          { name: '个人中心', path: '/personal' },
        ]
      },
    }, {
      path: '/successCase/:type_id',
      name: 'successCase',
      component: SuccessCase,
      meta: {
        title: '海外医疗-出国看病-癌症-肿瘤-心血管-威马捷',
        routeInfo: [
          { name: '成功案例', path: '/successCase' },
        ]
      },
      children: [
        {
          path: '/successCase/list/:id/:disease_id/:type_id',
          name: 'successCaseList',
          component: SuccessCaseList,
          meta: {
            title: '服务案例-海外医疗-出国看病-远程咨询-二次诊疗-第二诊疗-威马捷',
            routeInfo: [
              { name: '首页', path: '/home' },
              { name: '成功案例', path: '/successCase/list' },
            ]
          },
        }
      ]
    }, {
      path: '/successCaseDetail/:id',
      name: 'successCaseDetail',
      component: SuccessCaseDetail,
      meta: {
        title: '海外医疗-出国看病-癌症-肿瘤-心血管-威马捷',
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '成功案例', path: '/successCase/list' },
          { name: '黑色素瘤患者就医记', path: '' }
        ]
      },
    }, {
      path: '/mail',
      name: 'mail',
      component: Mail,
      meta: {
        title: '站内信',
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '站内信', path: '/mail' },
        ]
      }
    }, {
      path: '/hospitalList/:type/:hospitalType',
      name: 'HospitalList',
      component: HospitalList,
      title: '日本医院-美国医院-德国医院-意大利医院-新加坡医院-瑞士医院-威马捷',
      meta: {
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '权威医院', path: '/hospitalList' },
        ]
      }
    }, {
      path: '/doctorList/:type',
      name: 'DoctorList',
      component: DoctorList,
      meta: {
        title: '权威医生-日本专家-美国专家-德国专家-新加坡专家-意大利专家-威马捷',
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '权威医生', path: '/doctorList' },
        ]
      }
    }, {
      path: '/doctorInfo/:id',
      name: 'DoctorInfo',
      component: DoctorInfo,
      meta: {
        title: '医生介绍',
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '权威医生', path: '/doctorList' },
          { name: '权威医生', path: '/doctorList' },
        ]
      }
    }, {
      path: '/hospitalInfo/:id',
      name: 'HospitalInfo',
      component: HospitalInfo,
      meta: {
        title: '日本医院-美国医院-德国医院-意大利医院-新加坡医院-瑞士医院-威马捷',
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '合作医院', path: '/doctorList' },
          { name: '医院XX', path: '/doctorList' },
        ]
      }
    }, {
      path: '/internationalIndex',
      name: 'InternationalIndex',
      component: InternationalIndex,
      meta: {
        title: '海外医疗-日本医疗-美国医疗-德国医疗-意大利医疗-新加坡医疗-威马捷',
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '出国看病', path: '/internationalIndex' }
        ]
      }
    }, {
      path: '/internationalMedicine',
      name: 'InternationalMedicine',
      component: InternationalMedicine,
      meta: {
        title: '出国看病-日本看病-美国看病-德国看病-意大利看病-新加坡看病-威马捷',
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '出国看病', path: '/internationalMedicine' }
        ]
      }
    }, {
      path: '/internationalBodyCheck',
      name: 'InternationalBodyCheck',
      component: InternationalBodyCheck,
      meta: {
        title: '海外体检-精密体检-早癌筛查-日本体检-新加坡体检-香港体检-威马捷',
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '精密体检', path: '/internationalBodyCheck' }
        ]
      }
    }, {
      path: '/internationalAntiAging',
      name: 'InternationalAntiAging',
      component: InternationalAntiAging,
      meta: {
        title: '海外医疗-抗衰老-日本干细胞-瑞士干细胞-威马捷',
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '抗衰老', path: '/internationalAntiAging' }
        ]
      }
    },
    {
      path: '/internationalMedicalVisa',
      name: 'InternationalMedicalVisa',
      component: InternationalMedicalVisa,
      meta: {
        title: '海外医疗-医疗签证',
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '医疗签证', path: '/internationalMedicalVisa' }
        ]
      }
    },
    {
      path: '/internationalAdvanced',
      name: 'InternationalAdvanced',
      component: InternationalAdvanced,
      meta: {
        title: '海外医疗-出国看病-重离子治疗-质子治疗-干细胞治疗-基因治疗-威马捷',
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '先进治疗', path: '/internationalAdvanced' }
        ]
      }
    }, {
      path: '/internationalConsultation',
      name: 'InternationalConsultation',
      component: InternationalConsultation,
      meta: {
        title: '海外医疗-出国看病-远程咨询-第二诊疗-二次诊疗-远程视频-威马捷',
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '远程咨询', path: '/internationalConsultation' }
        ]
      }
    }, {
      path: '/internationalDisease',
      name: 'InternationalDisease',
      component: InternationalDisease,
      meta: {
        title: '海外医疗-出国看病-癌症-肿瘤-心血管-威马捷',
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '疾病专题', path: '/internationalDisease' }
        ]
      }
    }, {
      path: '/japaneseMedical',
      name: 'JapaneseMedical',
      component: JapaneseMedical,
      meta: {
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '国际医疗', path: '/internationalMedicine' },
          { name: '日本治疗', path: '/japaneseMedical' },
          { name: '治疗', path: '/japaneseMedical' }
        ]
      }
    }, {
      path: '/corporateKnowledge',
      name: 'CorporateKnowledge',
      component: CorporateKnowledge,
      meta: {
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '公司见闻', path: '/corporateKnowledge' },
        ]
      }
    }, {
      path: '/corporateKnowledgeDetail/:id',
      name: 'CorporateKnowledgeDetail',
      component: CorporateKnowledgeDetail,
      meta: {}
    }, {
      path: '/form/:hid',
      name: 'Form',
      component: Form,
      meta: {
        title: '服务申请表',
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '精密体检表单', path: '/form' },
        ]
      }
    }, {
      path: '/formOfOne/:hid',
      name: 'FormOfOne',
      component: FormOfOne,
      meta: {
        title: '服务申请表',
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '其他医院表单', path: '/formOfOne/:hid' },
        ]
      }
    }, {
      path: '/formOfTwo/:hid',
      name: 'FormOfTwo',
      component: FormOfTwo,
      meta: {
        title: '服务申请表',
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '其他医院表单', path: '/formOfTwo/:hid' },
        ]
      }
    }, {
      path: '/formOfThree/:hid',
      name: 'FormOfThree',
      component: FormOfThree,
      meta: {
        title: '服务申请表',
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '其他医院表单', path: '/FormOfThree/:hid' },
        ]
      }
    }, {
      path: '/upload/:form_id',
      name: 'Upload',
      component: Upload,
      meta: {
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '上传资料', path: '/upload' },
        ]
      }
    }, {
      path: '/agreements/:hid',
      name: 'Agreements',
      component: Agreements,
    }, {
      path: '/signature',
      name: 'Signature',
      component: Signature,
      meta: {
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '签名', path: '/signature' },
        ]
      }
    }, {
      path: '/myfile',
      name: 'Myfile',
      component: Myfile,
      meta: {
        title: '我的资料',
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '我的资料', path: '/myfile' },
        ]
      }
    }, {
      path: '/illness',
      name: 'Illness',
      component: Illness,
      meta: {
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '疾病', path: '/illness' },
        ]
      }
    }, {
      path: '/pay/:id',
      name: 'Pay',
      component: Pay,
      meta: {
        title: '威马捷-支付',
        routeInfo: [
          { name: '首页', path: '/home' },
          { name: '支付', path: '/pay' },
        ]
      }
    }, {
      path: '/rescue',
      name: 'Rescue',
      component: Rescue,
      meta: {
        title: '全球救援-保险理赔-跨国转运-费用担保-医疗报告-威马捷-EAJ',
        // keepAlive: true
      }
    }, {
      path: '/rescueOfExpericence',
      name: 'RescueOfExpericence',
      component: RescueOfExpericence,
      meta: {
        title: '高铁转运-包机转运-跨国-转院-救护车-派遣医疗团队-威马捷'
      }
    }, {
      path: '/rescueOfPersonalized',
      name: 'RescueOfPersonalized',
      component: RescueOfPersonalized,
      meta: {
        title: '医疗保障-转运-医疗管理咨询-医务室-理赔-全球救援-威马捷'
      }
    }, {
      path: '/rescueOfWorldNet',
      name: 'RescueOfWorldNet',
      component: RescueOfWorldNet,
      meta: {
        title: '全球医院预约-医疗支付担保-医疗转运-跨国搬送-使馆援助-威马捷'
      }
    }, {
      path: '/rescueOfIndividualCase',
      name: 'RescueOfIndividualCase',
      component: RescueOfIndividualCase,
      meta: {
        title: '多语言客服-派遣翻译-转运-医疗咨询-理赔-免现金-打折-威马捷'
      }
    }, {
      path: '/rescueOfOverseasService',
      name: 'RescueOfOverseasService',
      component: RescueOfOverseasService,
      meta: {
        title: '多语言客服-派遣翻译-转运-医疗咨询-理赔-免现金-打折-威马捷'
      }
    }, {
      path: '/rescueOfOtherService',
      name: 'RescueOfOtherService',
      component: RescueOfOtherService,
      meta: {
        title: '24小时呼叫中心-行李丢失-飞机延误-赔偿责任-旅行援助-威马捷'
      }
    }, {
      path: '/rescueOfMemberService',
      name: 'RescueOfMemberService',
      component: RescueOfMemberService,
      meta: {
        title: '会员-医疗信息-免现金-翻译陪同-转院-转运-全球救援-威马捷'
      }
    }, {
      path: '/rescueOfEmergencyInChina',
      name: 'RescueOfEmergencyInChina',
      component: RescueOfEmergencyInChina,
      meta: {
        title: '挂账-垫付-免现金-预约医院-支付担保-转院-保险理赔-威马捷'
      }
    }, {
      path: '/rescueOfCustomerService',
      name: 'RescueOfCustomerService',
      meat: {
        title: '呼叫中心-医疗转运-回国-医疗报告-旅行援助-全球救援-威马捷'
      },
      component: RescueOfCustomerService,
    }, {
      path: '/rescueOfGlobalClub',
      name: 'RescueOfGlobalClub',
      component: RescueOfGlobalClub,
    }, {
      path: '/recruitment',
      name: 'Recruitment',
      meat: {
        title: '招聘信息'
      },
      component: Recruitment,
    }, {
      path: '/recruitmentInfo/:id',
      name: 'RecruitmentInfo',
      component: RecruitmentInfo,
    }, {
      path: '/submitQues',
      name: 'SubmitQues',
      component: SubmitQues,
    }, {
      path: '/vipService',
      name: 'VIPService',
      meat: {
        title: '赴日医疗福卡-海外医疗-出国看病-远程咨询-第二诊疗-二次诊断-威马捷'
      },
      component: VIPService
    },{
      path: '/sj/home',
      name: 'sj-home',
      component: SJHome,
    }, {
      path: '*',
      // name: 'home',SubmitQues
      component: Home
    },
  ]
})
